<template>
    <div>
        <div class="banner">
            <van-row>
                <van-col span="6" @click="back"><img class="back-icon" src="@/assets/share/home/back.png"></van-col>
                <van-col span="12">
                    <div class="banner-title">新的朋友</div>
                </van-col>
                <van-col span="6">
                </van-col>
            </van-row>
        </div>
        <div class="content">
            <div class="item" v-for="item in applyFriends">
                <img class="apply-icon" :src="item.userAvatar ? item.userAvatar : defaultImg">
                <div class="apply-user">
                    <div>{{item.userName}}</div>
                </div>
                <div class="agree-btn" @click="toConfirmAdd(item)">同意</div>
                <div class="refuse-btn" @click="refuse(item)">拒绝</div>
                <div class="apply-info-box" v-if="item.applicationInformation">
                    <div class="apply-info">{{item.applicationInformation}}</div>
                </div>
            </div>
            <div class="item"
                 v-for="item in refuseFriends"
                 @touchstart="gtouchstart(item.id)"
                 @touchmove="gtouchmove()"
                 @touchend="gtouchend()"
            >
                <img class="apply-icon" :src="item.userAvatar ? item.userAvatar : defaultImg">
                <div class="apply-user">
                    <div>{{item.userName}}</div>
                </div>
                <div class="refuse-info">拒绝了你的邀请</div>
            </div>
            <div class="item" v-for="item in friendList"
                 @touchstart="gtouchstart(item.id)"
                 @touchmove="gtouchmove()"
                 @touchend="gtouchend()"
            >
                <img class="apply-icon" :src="item.userAvatar ? item.userAvatar : defaultImg">
                <div class="apply-user">
                    <div>{{item.userName}}</div>
                </div>
                <div class="add-info">已添加</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Dialog, Toast} from 'vant';

    export default {
        name: 'applyList',
        data() {
            return {
                defaultImg: require('@/assets/share/home/noImg.png'),
                applyFriends: [],
                refuseFriends: [],
                friendList: []
            }
        },
        mounted() {
            this.getApplyList();
        },
        methods: {
            back() {
                this.$router.back();
            },
            getApplyList() {
                this.$api.share.getApplyList().then(res => {
                    this.applyFriends = res.info.applyFriends;
                    this.refuseFriends = res.info.refuseFriends;
                    this.friendList = res.info.friends;
                })
            },
            toConfirmAdd(item) {
                localStorage.setItem("addUser", JSON.stringify(item));
                localStorage.setItem("remark", item.userName);
                this.$router.push({
                    name: 'confirmAdd'
                })
            },
            gtouchstart(id) {
                // 开始触摸 长按1秒
                this.timeOutEvent = 0;
                this.timeOutEvent = setTimeout(() => {
                    Dialog.confirm({
                        message: '是否删除？',
                        getContainer: "#app",
                        confirmButtonColor: '#20D38F',
                        confirmButtonText: '是',
                        cancelButtonText: '否',
                        cancelButtonColor: '#ffffff',
                    }).then(() => {
                        this.$api.share.deleteMembers({
                            id
                        }).then(res => {
                            Toast('删除成功！');
                            this.getApplyList();
                        })
                    }).catch(() => {
                        // on cancel
                    });
                }, 1000)
            },
            gtouchmove() {
                clearTimeout(this.timeOutEvent);
                this.timeOutEvent = 0
            },
            gtouchend() {
                clearTimeout(this.timeOutEvent);
                this.timeOutEvent = 0
            },
            refuse (item) {
                this.$api.share.refuseApply({
                    id: item.id
                }).then(res => {
                    Toast({message:'拒绝成功！'});
                    this.getApplyList()
                })
            }
        }
    }
</script>

<style scoped>

    .apply-icon {
        width: 30px;
        height: 30px;
        background: #FFFFFF;
        border: 2px solid rgba(255,255,255,0.69);
        border-radius: 50%;
        margin-left: 22px;
        margin-top: 13px;
        vertical-align: bottom;
    }

    .item {
        width: 345px;
        background: #202020;
        opacity: 1;
        border-radius: 6px;
        margin: 15px auto;
        position: relative;
        padding-bottom: 13px;
    }

    .apply-user {
        display: inline-block;
        font-size: 14px;
        color: #ffffff;
        opacity: 0.9;
        height: 32px;
        line-height: 32px;
    }

    .agree-btn {
        width: 46px;
        height: 20px;
        border-radius: 10px;
        background: #20D38F;
        font-size: 12px;
        color: #FFFFFF;
        opacity: 0.9;
        position: absolute;
        top: 18px;
        right: 78px;
        text-align: center;
        line-height: 20px;
    }

    .refuse-btn {
        width: 46px;
        height: 20px;
        border-radius: 10px;
        border: 1px solid #7A7A7A;
        font-size: 12px;
        color: #FFFFFF;
        opacity: 0.9;
        position: absolute;
        top: 18px;
        right: 20px;
        text-align: center;
        line-height: 20px;
    }

    .apply-info-box {
        width: 305px;
        height: 33px;
        background: #000000;
        opacity: 1;
        border-radius: 4px;
        margin: 12px auto 0;
    }

    .apply-info {
        font-size: 12px;
        color: #FFFFFF;
        opacity: 0.9;
        padding: 10px 14px;
    }

    .refuse-info {
        position: absolute;
        right: 17px;
        top: 21px;
        color: #E24160;
        opacity: 0.9;
        font-size: 14px;
    }

    .add-info {
        position: absolute;
        right: 17px;
        top: 21px;
        color: #ffffff;
        opacity: 0.9;
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/views/share/applyList.vue